import React from "react";
import './Footer.css';
import { NavLink } from "react-router-dom";



function Footer() {
    return (
        <div className="footer">
            <div>
                <img src={require('../assets/pixala clikd(1).png').default} className="website-logo" alt="pict" />

            </div>
            <ul className="left-part">
                <li><NavLink className="footer-list" to="/">HOME</NavLink> </li>
                <li><NavLink className="footer-list" to="/About">ABOUT US</NavLink> </li>
                <li><NavLink className="footer-list" to="/Contact">CONTACT US</NavLink> </li>
                <li><NavLink className="footer-list" to="">BLOG</NavLink> </li>
                <li><NavLink className="footer-list" to="/">ElPixala</NavLink> </li>
            </ul>
            <div className="right-part">
                <form id="subscribe">
                    <input type="search" className="subs" placeholder="Your Email " />
                    <button type="submit" className="subbtn"> Subscribe</button>
                </form>
                <div className="connect">
                    <h3>Connect With Us</h3>
                    <ul className="social">
                        <li><NavLink className="footer-list" to="/">Facbook</NavLink> </li>
                        <li><NavLink className="footer-list" to="/About">Twitter</NavLink> </li>
                        <li><NavLink className="footer-list" to="/Contact">YouTube</NavLink> </li>
                        <li><NavLink className="footer-list" to="/Blog">Twitch</NavLink> </li>
                    </ul>
                </div>
            </div>
        </div>

    )
}
export default Footer;